<template>
  <div class="main-wrapper medical">
    <div class="container">
      <div class="invoice-wrapper download_section">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-left">
              <h4>Tax Invoice</h4>
              <div class="company-details">
                <div class="gst-details">
                  Address:
                  <span>15 Hodges Mews, High Wycombe HP12 3JL, United Kingdom.</span>
                </div>
                <div class="address-bg"></div>
              </div>
            </div>
            <div class="inv-header-right">
              <a href="javascript:;">
                <img src="@/assets/img/logo2.png" alt="Logo" />
              </a>
              <h3>Dreams Medical</h3>
            </div>
          </div>
          <h5>Patient Information</h5>
          <div class="patient-info">
            <div class="patient-details">
              <div>Patient Name : <span>Micle Richard </span></div>
              <div>Patient Birth Date :<span>32 Years Old - 22 July 1991</span></div>
              <div>Insurence Billed :<span>WPS</span></div>
              <div>Patient No :<span>123456789</span></div>
            </div>
            <div class="treatment-info me-0">
              <div>Service : <span>Dental Treatment </span></div>
              <div>Due Date : <span>25 Dec 2022</span></div>
              <div>
                Address : <span>4 Balmy Beach Road, Owen Sound, Ontario, Canada</span>
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Item</th>
                    <th class="text-center">Rate/Item</th>
                    <th class="text-center">Qty</th>
                    <th class="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">Dental Treatment</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">Bed Charge</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td class="table-description">Consultant Surgeon Fee</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td class="table-description">Nursing Service Charge</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td class="table-description">Medical Hospital Supply</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td class="table-description">Dental Treatment</td>
                    <td class="text-center">$100</td>
                    <td class="text-center">1</td>
                    <td class="text-end">$100</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer border border-0 py-0">
            <div class="table-footer-left notes"></div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Taxable Amount</td>
                    <td>$600.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer pt-0">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>$6.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer table-total-item">
            <div class="table-footer-left">
              <span class="total-item">Total Items / Qty : 6 / 6.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Total Amount</td>
                    <td class="invoice-title">$606.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="total-amountdetails">
            <p>
              Total amount ( in words): <span>INR Six Hundred Six Dollers Only.</span>
            </p>
          </div>
          <div class="bank-details">
            <div class="payment-info">
              <span class="payment-title">Payment Info:</span>
              <div><span>Debit Card :</span> 465 *************645</div>
              <div class="mb-0"><span>Amount :</span> $1,815</div>
            </div>
            <div class="terms-condition">
              <span>Terms & Conditions:</span>
              <ol>
                <li>Goods Once sold cannot be taken back or exchanged</li>
                <li>
                  We are not the manufactures, company will stand for warrenty as per
                  their terms and conditions.
                </li>
              </ol>
            </div>
          </div>

          <div class="thanks-msg text-center">Thanks for your Business</div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
